import { render, staticRenderFns } from "./kefuFullscreen.vue?vue&type=template&id=f65e02c4&scoped=true"
import script from "./kefuFullscreen.vue?vue&type=script&lang=js"
export * from "./kefuFullscreen.vue?vue&type=script&lang=js"
import style0 from "./kefuFullscreen.vue?vue&type=style&index=0&id=f65e02c4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f65e02c4",
  null
  
)

export default component.exports